import { Directive, ElementRef, OnDestroy, Renderer2, inject, input } from '@angular/core';

// eslint-disable-next-line @angular-eslint/directive-selector
@Directive({ selector: '[skipNavigation][routerLink]' })
export class SkipNavigationDirective implements OnDestroy {
    private ref = inject<ElementRef<HTMLAnchorElement>>(ElementRef);
    private renderer = inject(Renderer2);

    public readonly skipNavigation = input(false);

    private unsubscribe: () => void;

    constructor() {
        const ref = this.ref;
        const renderer = this.renderer;

        this.unsubscribe = renderer.listen(ref.nativeElement, 'click', (event: MouseEvent) => {
            if (this.skipNavigation()) {
                event.stopImmediatePropagation();
                event.stopPropagation();
                event.preventDefault();
            }
        });
    }

    ngOnDestroy() {
        this.unsubscribe();
    }
}
